import { Icon } from '@iconify/react';
import { motion } from 'framer-motion';

export default function ServiceOutlineBox({ icon, title, children, ...props }) {
  return (
    <motion.div
      className="flex flex-col items-center rounded-xl border-2 border-primary-500 p-8"
      {...props}
    >
      <Icon className="text-primary-500" height="64" icon={icon} />
      <h4 className="mt-2 text-center text-xl font-semibold md:text-2xl">{title}</h4>
      <div className="mt-4">{children}</div>
    </motion.div>
  );
}
